export enum CreatingCardType {
  SINGLE = 'Single',
  MULTIPLE = 'Multiple',
  FULL_SCRIPT = 'Full_script',
}
